import React from "react";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@mui/icons-material";
import styled from "styled-components";
import { sliderItems } from "../data";
import { useState } from "react";
import { mobile } from "../responsive";

const Container = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  background-color: coral;
  position: relative;
  overflow: hidden;
  ${mobile({ display: "none" })};
`;

const Arrow = styled.div`
  width: 50px;
  height: 50px;
  background-color: #000;
  border-radius: 50%;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  opacity: 0.7;
  top: 45%;
  margin: auto;
  z-index: 2;
`;

const Wrapper = styled.div`
  height: 100%;
  background: #fff7f7;
  display: flex;
  transform: translateX(${(props) => props.slideIndex * -100}vw);
  transition: all 1.5s ease;
`;

const Slide = styled.div`
  width: 100vw;
  height: 100hv;
  display: flex;
  align-items: center;
  background-color: #${(props) => props.bg};
`;

const ImgContainer = styled.div`
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  height: 80%;
`;

const InfoContainer = styled.div`
  flex: 1;
  padding: 50px;
`;

const Title = styled.h1`
  font-size: 70px;
`;

const Desc = styled.p`
  margin: 50px 0;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 3px;
`;

const Button = styled.button`
  padding: 10px;
  font-size: 20px;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    background-color: #000;
    color: white;
    transition: all 0.4s ease;
  }

  &:active {
    background-color: transparent;
    color: #000;
  }
`;

const Slider = () => {
  const [slideIndex, setSlideIndex] = useState(0);

  // var timer = setInterval(() => {
  //   setSlideIndex(slideIndex < 2 ? slideIndex + 1 : 0);
  // }, 3000);

  const handleClick = (direction) => {
    // clearInterval(timer);
    if (direction === "left") {
      setSlideIndex(slideIndex > 0 ? slideIndex - 1 : 2);
    } else {
      setSlideIndex(slideIndex < 2 ? slideIndex + 1 : 0);
    }
    // timer = setInterval(() => {
    //   setSlideIndex(slideIndex < 2 ? slideIndex + 1 : 0);
    // }, 3000);
  };

  return (
    <Container>
      <Arrow
        direction="left"
        style={{ left: 10 }}
        onClick={() => handleClick("left")}
      >
        <ArrowLeftOutlined style={{ color: "white" }} />
      </Arrow>

      <Wrapper slideIndex={slideIndex}>
        {sliderItems.map((item) => {
          return (
            <Slide bg={item.bg} key={item.id}>
              <ImgContainer>
                <Image src={item.img} />
              </ImgContainer>
              <InfoContainer>
                <Title>{item.title}</Title>
                <Desc>{item.desc}</Desc>
                <Button>SHOP NOW</Button>
              </InfoContainer>
            </Slide>
          );
        })}
      </Wrapper>

      <Arrow
        direction="right"
        style={{ right: 10 }}
        onClick={() => handleClick("right")}
      >
        <ArrowRightOutlined style={{ color: "white" }} />
      </Arrow>
    </Container>
  );
};

export default Slider;
